const getRefundsWidgets = (ctx) => {
  return {
    name: '',
    rightWidgets: [
      {
        icon: 'CreditCardIcon',
        code: 'successRate',
        name: ctx.$t('stats.countOfRefunds'),
        color: "warning",
        delimited: false,
        symbol: '',
        type: 'numberOfRefunds',
        data: null
      },
      {
        icon: 'CreditCardIcon',
        code: 'successRate',
        name: ctx.$t('stats.sumOfRefunds'),
        color: "warning",
        delimited: false,
        symbol: '',
        type: 'sumOfRefunds',
        data: null
      }
    ]
  }
}

export default getRefundsWidgets